import { TIME_LINE_BLOCK_RECEIVE, TIME_LINE_BLOCK_ERROR } from './TimeLineBlock.action';
import { error as errorReducer } from '../../../Reducers/Error.reducer';

const defaultState = {
    result: []
}
export const TimeLineReducer = (state = defaultState, action) => {
    switch (action.type) {
        case TIME_LINE_BLOCK_RECEIVE:
            return {
                ...state,
                result: [...state.result, action.payload],
            }
        case TIME_LINE_BLOCK_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        default:
            return state;
    }
}